import { useContext } from 'react';
import { CurrentUserContext, CurrentUserContextValue } from '../context/CurrentUserContext';
export function useCurrentUser() {
  return useContext(CurrentUserContext);
}